module.exports = __webpack_public_path__ + "img/br.155348d0.svg";